import { Link } from "@tanstack/react-router";
import type { Car } from "@/lib/cars";
import { Button } from "@/components/ui/button";

export function MobileRateCard({ car, booking = false }: { car: Car; booking?: boolean }) {
  return (
    <article className="min-w-0 rounded-md border border-border bg-card p-5">
      <h3 className="font-display text-2xl text-foreground">
        <Link to="/fleet/$slug" params={{ slug: car.slug }} className="hover:underline">
          {car.name}
        </Link>
      </h3>
      <p className="mt-2 text-xs text-muted-foreground">All rates in Canadian dollars (CAD).</p>
      <dl className="mt-5 grid grid-cols-2 gap-x-4 gap-y-5">
        {[
          { label: "24 hours", value: car.rates.h24 },
          { label: "48 hours", value: car.rates.h48 },
          { label: "3-6 days", value: car.rates.d36 },
          { label: "7+ days", value: car.rates.d7 },
        ].map((rate) => (
          <div key={rate.label} className="min-w-0">
            <dt className="text-sm text-muted-foreground">{rate.label}</dt>
            <dd className="mt-1 text-base font-medium text-foreground">{rate.value}</dd>
          </div>
        ))}
      </dl>
      <dl className="mt-5 border-t border-border text-sm">
        {[
          { label: "Included km", value: car.rates.kmIncluded },
          { label: "Extra km", value: car.rates.extraKm },
          { label: "Security deposit", value: car.rates.security },
          { label: "LDW", value: car.rates.ldw },
        ].map((item) => (
          <div key={item.label} className="flex items-baseline justify-between gap-4 border-b border-border py-3">
            <dt className="text-muted-foreground">{item.label}</dt>
            <dd className="text-right font-medium text-foreground">{item.value}</dd>
          </div>
        ))}
      </dl>
      {booking && <>
        <p className="mt-3 text-sm text-muted-foreground">CAD, before taxes. Mandatory LDW is additional; the deposit is refundable.</p>
        <Button asChild className="mt-4 w-full h-12 rounded-none shadow-none uppercase tracking-widest text-xs"><a href="/book">Book Now</a></Button>
      </>}
    </article>
  );
}